<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div class="row items-center">
        <div class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Lista de Usuários
        </div>
      </div>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-sm text-brand-1 text-weight-medium"
        >
          <span>Utilize os campos abaixo para filtrar os usuários.</span>
        </div>
        <div
          class="row col-12 q-gutter-sm text-brand-1 text-weight-bold q-ml-sm items-center"
        >
          <div class="col-3">
            <div class="q-ml-sm">Unidade</div>
            <UnidadeSelect v-model="filtros.unidade" />
          </div>
          <div class="col-3">
            <div class="q-ml-sm">Ghe</div>
            <SelectGhe v-model="filtros.ghe" />
          </div>
          <div class="col-3">
            <div class="q-ml-sm">Centro de Custo</div>
            <SelectCentroCusto v-model="filtros.centroCusto" />
          </div>
          <div class="col-3">
            <div class="q-ml-sm">Turno</div>
            <q-select
              dense
              outlined
              label="Selecione o Turno."
              label-color="grey-6"
              v-model="filtros.turno"
              :options="optionsTurno"
            />
          </div>
          <div>
            <div class="q-mt-xs">
              <q-btn
                class="q-mt-md"
                style="
                  border-radius: 8px;
                  background-color: #7ab9e0;
                  color: white;
                "
                label="Filtrar"
                icon="filter_alt"
                no-caps
                @click="atualizarTabela()"
              />
            </div>
          </div>
          <div>
            <div class="q-mt-xs">
              <q-btn
                class="q-mt-md"
                style="
                  border-radius: 8px;
                  background-color: #304f78;
                  color: white;
                "
                label="Atualizar Biometria"
                icon="sync"
                no-caps
                @click="atualizarBiometriaFuncionarios()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="q-mt-lg">
      <div class="row col-12">
        <q-tabs
          v-model="tab"
          style="padding: 0px; margin: 0px"
          dense
          class="q-mt-xl col text-grey-7"
          active-color="black"
          no-caps
          active-bg-color="brand-11"
          indicator-color="transparent"
          align="justify"
        >
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="usuarios"
            label="Lista de Usuários"
          />
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            class="q-ml-sm q-mr-sm"
            name="usuariosAfastado"
            label="Usuários Afastados"
          />
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="usuariosDesligados"
            label="Usuários Desligados"
          />
        </q-tabs>
        <q-input
          class="q-ml-md"
          label="Pesquisar Usuário"
          label-color="grey-6"
          dense
          v-model="filtros.search"
          outlined
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <div class="col-12 q-mt-sm">
        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="usuarios">
            <TabelaUsuarios
              :listaTabela="listaUsuarios"
              :tipoTabela="'usuarios'"
              :loading="loading"
              @atualizar="atualizarTabela"
            />
          </q-tab-panel>
          <q-tab-panel name="usuariosAfastado">
            <TabelaUsuarios
              :listaTabela="listaUsuarios"
              :tipoTabela="'usuariosAfastado'"
              :loading="loading"
              @atualizar="atualizarTabela"
            />
          </q-tab-panel>
          <q-tab-panel name="usuariosDesligados">
            <TabelaUsuarios
              :listaTabela="listaUsuarios"
              :tipoTabela="'usuariosDesligados'"
              :loading="loading"
              @atualizar="atualizarTabela"
            />
          </q-tab-panel>
        </q-tab-panels>
        <div v-if="listaUsuarios.length > 0" class="row col-12 justify-center">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import UnidadeSelect from "../../../components/unidade/UnidadeSelect.vue";
import TabelaUsuarios from "../components/TabelaUsuarios.vue";
import SelectGhe from "../components/SelectGhe.vue";
import SelectCentroCusto from "../../legado/compras/components/SelectCentroCustos.vue";

const store = useStore();
const quasar = useQuasar();

const filtros = ref({
  unidade: "",
  ghe: "",
  centroCusto: "",
  turno: "",
  search: "",
});
const tab = ref("usuarios");
const listaUsuarios = ref([]);
const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 15,
  rowsNumber: 6,
});
const loading = ref(false);
const disable = ref(false);
const optionsTurno = ref([
  {
    label: "Turno da Manhã - 06:00:00 / 12:00:00",
    value: 1,
  },
  {
    label: "Turno da Noite - 19:10:00 / 21:10:00",
    value: 7,
  },
]);

const listarUsuarios = async (page = 1) => {
  loading.value = true;
  disable.value = true;
  try {
    const response = await store.dispatch("usuarioNovo/listarFuncionarios", {
      perPage: 15,
      page: page,
      vendorId: filtros.value.unidade?.id,
      costCenterId: filtros.value.centroCusto?.id,
      gheId: filtros.value.ghe?.id,
      search: filtros.value.search,
    });
    listaUsuarios.value = response.data.results.data;
    pagination.value.page = response.data.results.current_page;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    disable.value = false;
    loading.value = false;
  } catch (error) {
    console.log(error);
    loading.value = false;
    disable.value = false;
  }
};

const atualizarBiometriaFuncionarios = async () => {
  try {
    await store.dispatch("usuarioNovo/atualizarBiometriaFuncionarios");
    atualizarTabela();
    quasar.notify({
      message: "A atualização está sendo processada.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
  }
};

const atualizarTabela = (page) => {
  if (tab.value === "usuarios") {
    listarUsuarios(page);
    return;
  }
  listaUsuarios.value = [];
  pagination.value = {
    sortBy: "desc",
    descending: false,
    page: 1,
    rowsPerPage: 15,
    rowsNumber: 6,
  };
};

const pagesNumber = computed(() =>
  Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
);

watch(
  () => tab.value,
  () => {
    atualizarTabela();
  }
);

watch(
  () => pagination.value.page,
  () => {
    atualizarTabela(pagination.value.page);
  }
);

onMounted(() => {
  atualizarTabela();
});
</script>

<style scoped>
a {
  text-decoration: none;
}
.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.q-tab-panel {
  padding: 0px;
  margin: 0px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
